var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"mb-4 mb-lg-0",attrs:{"cols":"12","lg":"4","offset-lg":"2"}},[_c('img',{attrs:{"src":"","alt":""}})]),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }